import pl from "@locales/empty_states/pl.json";
import en from "@locales/empty_states/en.json";
export default {
  pl: pl,
  en: en,
};
